import type { JSX } from "react";
import { Navigate, useMatch } from "react-router-dom";
import { useQuery } from "urql";
import Loader from "../../shared/components/Loader";
import t from "../../shared/translations";
import LockedModal, { useLockedModal } from "../LockedModal";
import ShowError from "../components/ShowError";
import WithTasksSidebar from "../tasksSidebar";
import TaskChoiceDescription from "./TaskChoiceDescription";
import { type IArgs, type IData, query } from "./query";

function PathInPath(): JSX.Element {
    const {
        params: { id },
    } = useMatch({ path: "/task-choice/:id/" });
    const { openLockedModal, ...lockedProps } = useLockedModal();
    const [result] = useQuery<IData, IArgs>({
        query,
        variables: { id },
    });

    let main = <div />;
    if (result.fetching) {
        main = <Loader />;
    } else if (result.error) {
        main = <ShowError />;
    } else if (!result.data.taskChoice) {
        main = <Navigate to="/landing" replace={true} />;
    } else {
        const taskChoice = result.data.taskChoice;
        main = <TaskChoiceDescription taskChoice={taskChoice} />;
    }

    return (
        <>
            <WithTasksSidebar
                openLockedModal={openLockedModal}
                activeItem={result.data?.taskChoice?.learningPathItem?.id}
                mainLabel={t("player.task-choice.tab-task-choice")}
                big={true}
            >
                {main}
            </WithTasksSidebar>
            <LockedModal {...lockedProps} />
        </>
    );
}

export default PathInPath;
